"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Tab_1 = tslib_1.__importDefault(require("@mui/material/Tab"));
const Tabs_1 = tslib_1.__importDefault(require("@mui/material/Tabs"));
const styles_1 = require("@mui/material/styles");
const DateTimeFilterTabs = (props) => {
    const { tabs, ...rest } = (0, styles_1.useThemeProps)({
        props,
        name: "DateTimeFilterTabs",
    });
    return (react_1.default.createElement(Tabs_1.default, { sx: {
            "& .MuiTabs-flexContainer": {
                display: "flex",
                justifyContent: "space-between",
            },
        }, ...rest }, tabs?.map((tab, idx) => {
        return react_1.default.createElement(Tab_1.default, { key: idx, ...tab });
    })));
};
exports.default = DateTimeFilterTabs;
